<template>
  <transition name="fade" appear>
    <div class="guests-modal" @click="$emit('close')">
      <div @click.stop.prevent>
        <div>
          <h2>Enter Additional Guest Details</h2>
        </div>
        <div class="guests-headers">
          <p></p>
          <p>First Name*</p>
          <p>Last Name*</p>
          <p>Email Address</p>
          <p></p>
        </div>
        <div class="guests-info">          
          <GuestInfo
            v-for="(guest, id) in guests"
            :guest="id"
            :info="guest"
            @removeGuest="removeGuest"
            :key="guest"
          />
          <Button
            text="Add a Guest"
            link=""            
            @click="
              $emit('addGuest');
              guests.push({ first: '', last: '', email: '' });
            "
            class="add-guest"
            v-show="numGuests < 3"
          />
        </div>
        <div class="appointment">
          <h2>Your Appointment is on<br/><span>{{selectedBooking}}</span></h2>
        </div>
        <div class="ui">          
          <Button
            text="Back"
            link=""            
            @click="
              $emit('close');
              $emit('done', finalGuests());
            "
          />
          <Button            
            text="Book Now"
            link=""                            
            @click="submitAppointment"
            :class="{ disabled: numGuests !== finalGuests().length }"
            class="submit"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import GuestInfo from "@/components/GuestInfo";
import Button from "@/components/Button";
export default {
  name: "GuestModal",
  props: {
    numGuests: Number,
    currentGuestInfo: Array,
  },
  components: {
    GuestInfo,
    Button,
  },
  computed: {
    selectedBooking() {
      let dayOptions = {
        weekday: "short",
        month: "short",
        day: "numeric",
      };
      let timeOptions = {     
        hour:'numeric',
        minute:'2-digit',
        hour12: true
      };

      let booking = new Date(this.$store.state.selectedBooking);
      return `${booking.toLocaleDateString("en-US", dayOptions)} at ${booking.toLocaleTimeString("en-US", timeOptions)}`;
    }
  },
  methods: {
    removeGuest(id) {
      this.guests.splice(id, 1);
      this.$emit("removeGuest");
      if(this.guests.length === 0){
        this.$emit('close');
      }
    },
    submitAppointment() {
      if(this.numGuests !== this.finalGuests().length) {
        alert('Please enter your guests additional info.')
        return;
      }
      this.$emit('done', this.finalGuests());
      this.$emit('submitAppointment');
    },
    finalGuests() {
      let guests = this.guests.filter((guest) => {       
        return (
          (guest.first.trim() !== "" && guest.last.trim() !== "") &&
          (guest.email.trim() === "" || (guest.email.trim() !== "" && this.testEmail.test(guest.email.trim())))
        );
      });
      return guests;
    },
  },
  mounted() {
    let guests = [];
    if (this.currentGuestInfo) {
      guests = this.currentGuestInfo;
    }
    for (let index = guests.length; index < this.numGuests; index++) {
      guests.push({ first: "", last: "", email: "" });
    }
    this.guests = guests;
  },
  data() {
    return {
      guests: [],
      testEmail: /^.+@.+\..+$/,
    };
  },
};
</script>

<style lang="scss" scoped>
button {
  &.disabled {
    opacity: 0.2;
  }
}
.add-guest {
  align-self: flex-start;
  @media (max-width:850px) {
    width:100%;
  }
}
.guests-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.85);
  display: grid;
  place-items: center;
  overflow: auto;
   &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--accent);
  }
  > div {
    overflow: hidden;
    background: linear-gradient(89.84deg, rgba(217, 217, 217, 0.03) 0.15%, rgba(217, 217, 217, 0.1) 51.51%, rgba(217, 217, 217, 0.03) 99.89%);
    background-color:#000;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    font-size: 1rem;
  }
}
.guests-headers {
  padding: 0 15px;
  text-align: left;
  display:none;
  grid-template-columns: 75px 1fr 1fr 1fr 40px;
  gap:5px;
  color:var(--white);
  p {
    padding: 0 30px;
    font-size: 0.875rem;
    font-weight: 800;
    text-transform: uppercase;
  }
  @media (min-width:850px) {
    display:grid;
  }
}
.guests-info {
  padding: 25px 15px;
  padding-top:0;
  text-align: left;
  display:flex;
  flex-direction: column;
  gap:10px;
  max-height:60vh;
  overflow: auto;
}
.ui {
  padding: 15px 0;
  display: flex;
  gap: 5px;
  justify-content: center;
}
h2 {
  color: var(--white);
  text-align: left;
  padding: 15px;
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  border-bottom:1px solid var(--blue);
}

</style>